<template>
  <a-card size="small">
    <template #title>待选列表 - {{ value.length }}项</template>
    <template #extra>
      <a-button size="small" type="link" @click="remove">删除选中</a-button>
    </template>

    <!-- <a-table
      row-key="id"
      size="small"
      :bordered="true"
      :data-source="value"
      :columns="columns"
      :scroll="{ x: true }"
      :pagination="{
        simple: true,
        current: current,
        pageSize: 5,
        total: value.length,
      }"
      :row-selection="{
        selectedRowKeys: selectedIds,
        onChange: onSelectionChange,
        fixed: true,
      }"
      @change="onTableChange"
    >
    </a-table> -->
     <table-wrapper
      :row-key="'materialId'"
      size="small"
      ref="tableRef"
      :bordered="true"
      :data-source="value"
      :columns="columns"
      :tableHeight="tableHeight"
      @onSelectionChange="onSelectionChange"
    ></table-wrapper>
  </a-card>
</template>

<script lang="ts">
import { defineComponent, PropType, reactive, toRefs } from "vue";
import { columns } from "./constant";
import { LibraryListRecord } from "@/views/material/library/library.interface";

export default defineComponent({
  name: "SelectedTable",
  props: {
    value: {
      type: Array as PropType<LibraryListRecord[]>,
      default: [],
    }, tableHeight: {
      type: Number,
      default: 0,
    },
  },
  emits: ["update:value"],
  setup(props, { emit }) {
    const state = reactive<{
      current: number;
      selectedIds: string[];
      columns: any[];
    }>({
      current: 1,
      selectedIds: [],
      columns,
    });

    const onSelectionChange = (ids: string[]) => {
      state.selectedIds = ids;
      // console.log(ids,'>>>>>>>>ids')
    };

    const onTableChange = async (pagination) => {
      state.current = pagination.current;
    };

    const remove = () => {
      const newValue = (props.value || []).filter((item:any) => !(state.selectedIds.includes(item.materialId)));
      state.selectedIds = [];
      emit("update:value", newValue);
    };

    return {
      ...toRefs(state),
      onSelectionChange,
      onTableChange,
      remove,
    };
  },
});
</script>
